// Auto-updated by bump-version.sh script
export const APP_VERSION = '2.0.0';
